import {types} from '../../types';

const setGetListTournamentAction = (payload) => {
    return {
        type: types.tournament.SET_LIST,
        payload,
      }
}

const setGetViewTournamentAction = (payload) => {
  return {
      type: types.tournament.SET_VIEW,
      payload,
    }
}

const setGetListTournamentStatAction = (payload) => {
  return {
    type: types.tournament.SET_LIST_STAT,
    payload,
  }
}

const setGetSearchGameAction = (payload) => {
  return {
    type: types.tournament.SET_SEARCH_GAME,
    payload
  }
}

export {
  setGetListTournamentAction as SetGetListTournamentAction,
  setGetViewTournamentAction as SetGetViewTournamentAction,
  setGetListTournamentStatAction as SetGetListTournamentStatAction,
  setGetSearchGameAction as SetGetSearchGameAction
}